// src/layouts/MainLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import LeftNav from "./leftNav/leftNav";
import Header from "./header/header";

const MainLayout = () => {
  return (
    <div className="pageMain">
      <LeftNav />
      <div className="pageRight">
        <div className="pageHead">
          <Header />
        </div>
        <div className="pageBody">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
